import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import SurveyListHeader from "../../../component/layout/MainHeader";
import Input from "../../../core/Inputs/DefaultInput";
import { toast } from 'react-toastify';
import './profile.css';
import * as Yup from "yup";
import Button from "../../../core/Button";
import AccountSettingSidebar from "./components/AccountSettingSidebar";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import NestedMenuToggle from "./NestedMenuToggle";
import { addSetting, getSettingList } from "../../../store/actions/settingAction";

const AwsSchema = Yup.object().shape({
  awsAccessKey: Yup.string().required("AWS Access Key is required"),
  awsSecretKey: Yup.string().required("AWS Secret Key is required"),
  awsBucketName: Yup.string().required("AWS Bucket Name is required"),
  awsBucketRegion: Yup.string().required("AWS Bucket Region is required"),
  awsAccessLink: Yup.string().required("AWS S3 Bucket Access Link is required"),
});

export default function Aws() {
  const dispatch = useDispatch();
  const { settingData } = useSelector((state) => state.settingData);

  const [formValue, setFormValue] = useState({
    awsAccessKey: "",
    awsSecretKey: "",
    awsBucketName: "",
    awsBucketRegion: "",
    awsAccessLink: "",
  });

  const handleSubmit = (values) => {
    dispatch(addSetting(values));
  };
  const handleGetSettingList = () => {
    let payload = {
      tag: 'aws',
    };
    dispatch(getSettingList(payload));
  }

  useEffect(() => {
    handleGetSettingList(); 
  }, [])

  const getAWSConfig = (selector) => {
    const config = {};
    selector.forEach(item => {
      switch (item.type) {
        case 'awsAccessKey':
          config.awsAccessKey = item.value;
          break;
        case 'awsSecretKey':
          config.awsSecretKey = item.value;
          break;
        case 'awsBucketName':
          config.awsBucketName = item.value;
          break;
        case 'awsBucketRegion':
          config.awsBucketRegion = item.value;
          break;
        case 'awsAccessLink':
          config.awsAccessLink = item.value;
        default:
          break;
      }
    });
    return config;
  };
  const awsConfig = useCallback(getAWSConfig(settingData), [settingData]);
  useEffect(() => {  
    setFormValue(awsConfig);  
  }, [awsConfig]);
  // const awsConfig = getAWSConfig(settingData);
  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 variable-pg-content">
              {/* breadcrumbs here */}
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      Home
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">Settings</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>Aws s3</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              {/* breadcrumbs ends here */}
              <div className="survey-main-container">
                <div className="page-heading d-lg-none">
                  <div className="d-flex align-items-start">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>Aws S3</h1>
                    </div>
                  </div>
                </div>
                <div className="pagesRow varPg">
                  <div className="profile-wrapper">
                    <div className="account-info border-0 pb-0">
                      <Formik
                        initialValues={formValue}
                        enableReinitialize
                        validationSchema={AwsSchema}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                          handleSubmit(values);
                          setSubmitting(false);
                          resetForm();
                          toast.success("Settings saved successfully");
                        }}
                      >
                        {({
                           values,
                           errors,
                           touched,
                           handleChange,
                           handleBlur,
                           handleSubmit,
                           isSubmitting,
                        }) => (
                          <form onSubmit={handleSubmit}>
                            <div className="form-wrapper custom-width">
                              <div className="row gx-12px">
                                <div className="col-lg-6 position-relative">
                                  <div className="mb-3">
                                    <label htmlFor="awsAccessKey">AWS Access Key</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="AWS Access Key"
                                      clearButton={true}
                                      success={false}
                                      error={errors.awsAccessKey && touched.awsAccessKey}
                                      fill={true}
                                      className={"formsinput"}
                                      name="awsAccessKey"
                                      value={values.awsAccessKey}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.awsAccessKey && touched.awsAccessKey && (
                                      <div className="validation-msg">
                                        {errors.awsAccessKey}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="mb-3">
                                    <label htmlFor="awsSecretKey">AWS Secret Key</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="AWS Secret Key"
                                      clearButton={true}
                                      success={false}
                                      error={errors.awsSecretKey && touched.awsSecretKey}
                                      fill={true}
                                      className={"formsinput"}
                                      name="awsSecretKey"
                                      value={values.awsSecretKey}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.awsSecretKey && touched.awsSecretKey && (
                                      <div className="validation-msg">
                                        {errors.awsSecretKey}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-6 position-relative">
                                  <div className="mb-3 cstom-select">
                                    <label htmlFor="awsBucketName">AWS Bucket Name</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="AWS Bucket Name"
                                      clearButton={true}
                                      success={false}
                                      error={errors.awsBucketName && touched.awsBucketName}
                                      fill={true}
                                      className={"formsinput"}
                                      name="awsBucketName"
                                      value={values.awsBucketName}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.awsBucketName && touched.awsBucketName && (
                                      <div className="validation-msg">
                                        {errors.awsBucketName}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-6 position-relative">
                                  <div className="mb-3 cstom-select">
                                    <label htmlFor="awsBucketRegion">AWS Bucket Region</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="AWS Bucket Region"
                                      clearButton={true}
                                      success={false}
                                      error={errors.awsBucketRegion && touched.awsBucketRegion}
                                      fill={true}
                                      className={"formsinput"}
                                      name="awsBucketRegion"
                                      value={values.awsBucketRegion}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.awsBucketRegion && touched.awsBucketRegion && (
                                      <div className="validation-msg">
                                        {errors.awsBucketRegion}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3 cstom-select">
                                    <label htmlFor="awsAccessLink">S3 Bucket Access Link</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="AWS S3 Bucket Access Link"
                                      clearButton={true}
                                      success={false}
                                      error={errors.awsAccessLink && touched.awsAccessLink}
                                      fill={true}
                                      className={"formsinput"}
                                      name="awsAccessLink"
                                      value={values.awsAccessLink}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.awsAccessLink && touched.awsAccessLink && (
                                      <div className="validation-msg">
                                        {errors.awsAccessLink}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="btn-wrap">
                                <button
                                  className={"formsbutton btn-bordered btn mb-0"}
                                  type="submit"
                                  view="outlined"
                                  color="primary"
                                  disabled={isSubmitting}
                                >
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
